import {Injectable} from '@angular/core';
import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {Scanner3dAccountModel} from '../scanner3dAccount.model';
import {Scanner3dConverter} from '../../../../common/api/entity/converter/scanner3d.converter';
import {LovValueSummaryConverter} from '../../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {Scanner3dAccountAgentConfigurationConverter} from "./scanner3dAccountAgentConfiguration.converter";

@Injectable()
export class Scanner3dAccountConverter extends HttpModelConverter<Scanner3dAccountModel> {

    constructor(private scanner3dConverter: Scanner3dConverter,
                private lovValueSummaryConverter: LovValueSummaryConverter,
                private scanner3dAccountAgentConfigurationConverter: Scanner3dAccountAgentConfigurationConverter) {
        super();
    }

    protected createInstance(): Scanner3dAccountModel {
        return new Scanner3dAccountModel();
    }

    protected enrichObject(result: Scanner3dAccountModel, src: Scanner3dAccountModel) {
        result.scanner = this.scanner3dConverter.convert(src.scanner);
        result.scanFormat = this.lovValueSummaryConverter.convert(src.scanFormat);
        result.scanMethod = this.lovValueSummaryConverter.convert(src.scanMethod);
        result.referencial = this.lovValueSummaryConverter.convert(src.referencial);
        result.footPosition = this.lovValueSummaryConverter.convert(src.footPosition);
        result.objectType = this.lovValueSummaryConverter.convert(src.objectType);
        result.agentConfiguration = this.scanner3dAccountAgentConfigurationConverter.convert(src.agentConfiguration);
    }
}
